import type { Dispatch, SetStateAction } from 'react';

import { AddressAutocompleteInput } from '../../../../shared/AddressAutocompleteInput';
import { Field, fieldStyle, STATES } from '../venueCreateFields';

import { Input } from './Input';
import { grid2 } from './section-props';
import { Select } from './Select';

export interface AddressDraft {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

/** The Address section's edit fields. Picking a suggested street address
 *  fills in city, state and ZIP; line 2 and country are left as they were. */
export function AddressEditForm({
  draft,
  setField,
  setDraft,
}: {
  draft: AddressDraft;
  setField: <K extends keyof AddressDraft>(key: K, value: AddressDraft[K]) => void;
  setDraft: Dispatch<SetStateAction<AddressDraft>>;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={grid2}>
        <Field label="Street" required>
          <AddressAutocompleteInput
            aria-label="Street"
            style={fieldStyle(undefined)}
            value={draft.addressLine1}
            onChange={(v) => setField('addressLine1', v)}
            onPick={({ addressLine1, city, state, zipCode }) =>
              setDraft((d) => ({ ...d, addressLine1, city, state, zipCode }))
            }
          />
        </Field>
        <Field label="Line 2">
          <Input
            value={draft.addressLine2}
            onChange={(v) => setField('addressLine2', v)}
            placeholder="Suite, floor…"
          />
        </Field>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 12 }}>
        <Field label="City" required>
          <Input value={draft.city} onChange={(v) => setField('city', v)} />
        </Field>
        <Field label="State" required>
          <Select value={draft.state} onChange={(v) => setField('state', v)} options={STATES} />
        </Field>
        <Field label="ZIP" required>
          <Input mono value={draft.zipCode} onChange={(v) => setField('zipCode', v)} />
        </Field>
        <Field label="Country">
          <Input value={draft.country} onChange={(v) => setField('country', v)} />
        </Field>
      </div>
    </div>
  );
}
